// extracted by mini-css-extract-plugin
export default {"wrapper":"f75909616dbf","noScreenshotThumbnail":"d4d3fb49efcc"};